import { render } from "./index.vue?vue&type=template&id=f5832120&scoped=true&bindings={\"isFocus\":\"props\",\"modelValue\":\"props\",\"label\":\"props\",\"noLabel\":\"props\",\"hint\":\"props\",\"errorHint\":\"props\",\"color\":\"props\",\"dark\":\"props\",\"inputSize\":\"props\",\"noClearButton\":\"props\",\"borderStyle\":\"options\",\"colorStyle\":\"options\",\"hasClearButton\":\"options\",\"isDisabled\":\"options\",\"focusInput\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f5832120&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f5832120"

export default script